import { cn } from "@babackapp/customer-ui/lib/utils";

export function ReceiptLine({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "flex text-muted-foreground font-content tabular-nums text-sm",
        className,
      )}
      {...props}
    />
  );
}

export function ReceiptLineLabel({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return <span className={cn("flex-1", className)} {...props} />;
}

export function ReceiptLineValue({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return <span className={className} {...props} />;
}
